var _polygon, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "804px",
    height: "918px",
    viewBox: "0 0 804 918",
    enableBackground: "new 0 0 804 918",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.6772,
    y1: 966.8809,
    x2: 293.5745,
    y2: 96.5969
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DA4A3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2839,
    style: {
      stopColor: "#B34338"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5542,
    style: {
      stopColor: "#993E35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8002,
    style: {
      stopColor: "#893B33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#843A33"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "169.467,902.41 6,902.41 221.231,24.872 384.698,24.872 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.6772,
    y1: -177.9536,
    x2: 759.647,
    y2: 1061.5311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DA4A3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0891,
    style: {
      stopColor: "#CC483B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#AB4338"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5947,
    style: {
      stopColor: "#953E35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8184,
    style: {
      stopColor: "#883B33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#843A33"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M779.984,229.887C724.894,84.872,484.222-5.958,242.257,26.869H221.34l215.232,877.54h163.467 l-89.506-364.933C711.499,490.8,829.652,360.633,779.984,229.887z M491.75,426.323c-1.713,0.234-3.428,0.45-5.146,0.648 l-10.341-27.22l-70.124-285.906c99.993-1.341,197.408,52.794,226.789,130.129C665.455,329.606,602.248,411.246,491.75,426.323z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6d6b006869094f6b31bf185e5279bc85.svg";
export { ForwardRef as ReactComponent };